import { Box, Text } from '@wix/design-system';
import {
  StylesDerivedNativeActions,
  StylesDerivedNativeActionNames,
} from '@wix/editor-platform-host-integration-apis';
import React from 'react';

const ACTION_NAME_TITLE_MAPPER = {
  [StylesDerivedNativeActions.borderStyles]: 'Border',
  [StylesDerivedNativeActions.cornerStyles]: 'Corner',
  [StylesDerivedNativeActions.fillStyles]: 'Fill',
  [StylesDerivedNativeActions.globalColorsStyles]: 'Global Colors',
  [StylesDerivedNativeActions.shadowStyles]: 'Shadow',
  [StylesDerivedNativeActions.textStyles]: 'Text',
  [StylesDerivedNativeActions.spacingStyles]: 'Spacing',
} as const;

// TODO: add translations
const StyleLobbyHeader = ({
  actionName,
  stylesCount,
}: {
  actionName: StylesDerivedNativeActionNames;
  stylesCount: number;
}) => {
  const title = ACTION_NAME_TITLE_MAPPER[actionName];

  if (!title) {
    return null;
  }

  return (
    <Box direction="vertical">
      <Text size="small" weight="bold">
        {title} ({stylesCount} Styles)
      </Text>
      <Text size="small" weight="thin">
        Select the style you want to edit
      </Text>
    </Box>
  );
};

export default StyleLobbyHeader;
